import { FC } from "react"
import { Outlet } from "react-router-dom"

const AdminPage: FC = () => {
  return <Outlet />
}

export default AdminPage
